import {
  cloudTypes,
  searchDropDownOptions,
  searchDropDownOptionMapping,
  standardLabraDateFormat,
} from '@labrav/common'

export {
  cloudTypes,
  searchDropDownOptions,
  searchDropDownOptionMapping,
  standardLabraDateFormat,
}

export const emptyUsageMeteringUrl =
  'https://docs.labra.io/docs/usage-metering-overview'

export const customDateRanges = [
  'Last 30 Days',
  'This Month',
  'Last Month',
  'Last 3 Months',
  'Last 6 Months',
  'This Year',
  'Last Year',
  'All Time',
]

export const statusUsage = ['Success', 'In-progress', 'Failed']
